import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const lsKey = (id: string) => `audience-ctx:${id}`;

/** Shared, cached `audience_get` for the audience + messages cards so AI buttons render instantly. */
export function useAudienceContext(base: Record<string, unknown>, campaignKnowledgeId: string) {
  const cached = (() => {
    try { const v = localStorage.getItem(lsKey(campaignKnowledgeId)); return v ? JSON.parse(v) : undefined; } catch { return undefined; }
  })();
  return useQuery({
    queryKey: ["audience-ctx", campaignKnowledgeId],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("company-profile-builder", { body: { ...base, action: "audience_get" } });
      if (error || data?.error) throw new Error(data?.error || error?.message || "failed");
      try { localStorage.setItem(lsKey(campaignKnowledgeId), JSON.stringify(data)); } catch { /* ignore */ }
      return data as Record<string, any>;
    },
    enabled: !!campaignKnowledgeId,
    initialData: cached,
    initialDataUpdatedAt: 0,
    staleTime: 10 * 60_000,
    retry: 1,
    // While the strategy's audience/messages are still being prepared in the background, check again.
    refetchInterval: (query) => ((query.state.data as any)?.preparing ? 4000 : false),
  });
}
